import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    FETCH_REVIEWS
    FETCH_REVIEWS_SUCCESS
    FETCH_REVIEWS_FAILURE
    SET_IS_SSR
`,
    {
        prefix: "customerReviews/"
    }
);
